import {
  type ComponentPropsWithoutRef,
  type PropsWithChildren,
  createContext,
  useContext,
  useLayoutEffect,
  useState,
} from 'react';

import { registerSupportingPaneRegion } from './supportingPaneRegistry';

const SupportingPaneOriginContext = createContext<boolean>(false);

export const useIsFromSupportingPane = (): boolean =>
  useContext(SupportingPaneOriginContext);

type SupportingPaneOriginProviderProps = PropsWithChildren<{
  isFromSupportingPane: boolean;
}>;

export const SupportingPaneOriginProvider = ({
  isFromSupportingPane,
  children,
}: SupportingPaneOriginProviderProps) => (
  <SupportingPaneOriginContext.Provider value={isFromSupportingPane}>
    {children}
  </SupportingPaneOriginContext.Provider>
);

export type SupportingPaneRegionProps = ComponentPropsWithoutRef<'div'>;

export const SupportingPaneRegion = ({
  children,
  ...rest
}: SupportingPaneRegionProps) => {
  const [element, setElement] = useState<HTMLDivElement | null>(null);

  useLayoutEffect(
    () => (element ? registerSupportingPaneRegion(element) : undefined),
    [element],
  );

  return (
    <SupportingPaneOriginProvider isFromSupportingPane>
      <div ref={setElement} {...rest}>
        {children}
      </div>
    </SupportingPaneOriginProvider>
  );
};
